
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("37xrd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ece60018b9830b8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $7ece60018b9830b8$export$2e2bcd8739ae039 = {
    'ai-mate.chat-error-banner.description': "Votre historique de chat est conserv\xe9 jusqu'\xe0 30\xa0jours.",
    'ai-mate.chat-error-banner.title': "D\xe9marrer un nouveau chat",
    'ai-mate.chat-error.description': 'Essayez de <btn>recharger le chat</btn>.',
    'ai-mate.chat-error.rate-limited-description': "Vous avez atteint le nombre maximal de demandes. Veuillez r\xe9essayer ult\xe9rieurement.",
    'ai-mate.chat-error.rate-limited-title': 'Trop de demandes',
    'ai-mate.chat-error.rovo-inactive-description': "Il semble que Rovo n'est pas activ\xe9 sur votre site. <link>Configurer Rovo</link>",
    'ai-mate.chat-error.rovo-inactive-title': 'Rovo est inactif',
    'ai-mate.chat-error.title': "Nous ne savons pas ce qui s'est pass\xe9",
    'ai-mate.main-chat.close-chat-button-label': 'Fermer',
    'ai-mate.main-chat.maximize-chat-button-label': "Plein \xe9cran",
    'ai-mate.main-chat.minimize-chat-button-label': 'Restaurer la vue',
    'ai-mate.main-chat.new-chat-button-label': 'Nouveau',
    'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nouveau chat',
    'conversation-assistant-button.label': 'Chat',
    'conversation-assistant-button.rovo-chat-label': "Chat\xa0Rovo",
    'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Envoyer',
    'highlight-actions.rovo-chat-custom-prompt.placeholder': "Interroger Atlassian Intelligence \xe0 ce sujet",
    'highlight-actions.rovo-chat-explain-option.text': 'Expliquer',
    'highlight-actions.rovo-chat-explain-prompt': "Expliquez votre pr\xe9f\xe9rence en reformulant la phrase et en ajoutant des d\xe9tails suppl\xe9mentaires, mais utilisez un langage tr\xe8s simple, des phrases courtes, et donnez des exemples ou une d\xe9finition \xe0 toute terminologie technique utilis\xe9e dans la formulation d'origine.",
    'highlight-actions.rovo-chat-find-resources-option.text': 'Rechercher des ressources',
    'highlight-actions.rovo-chat-find-resources-prompt': "Trouvez des ressources uniquement dans les connaissances organisationnelles qui valident les d\xe9clarations faites.",
    'highlight-actions.rovo-chat-give-examples-option.text': 'Donner des exemples',
    'highlight-actions.rovo-chat-give-examples-prompt': "Donnez-en des exemples tir\xe9s de ressources organisationnelles ou de connaissances publiques. Si vous n'avez aucune ressource \xe0 fournir, essayez de donner un exemple m\xe9taphorique qui pourrait aider quelqu'un \xe0 mieux comprendre les choses.",
    'highlight-actions.rovo-chat-give-feedback-option.text': 'Envoyer un commentaire',
    'highlight-actions.rovo-chat-give-feedback-prompt': "Commentez la formulation. Commentez le choix des mots, la grammaire et la ponctuation. Soyez positif et enthousiaste, mais sugg\xe9rez toujours au moins un \xe9l\xe9ment \xe0 am\xe9liorer ou \xe0 changer.",
    'highlight-actions.rovo-chat-more-options.tooltip': "Recommandations de Rovo\xa0Chat",
    'highlight-actions.rovo-chat-open-chat.tooltip': "Ouvrir Rovo\xa0Chat",
    'highlight-actions.rovo-chat-summarize-option.text': "R\xe9sumer",
    'highlight-actions.rovo-chat-summarize-prompt': "Soulignez les points cl\xe9s qui en d\xe9coulent. Concentrez-vous sur les informations essentielles et excluez les informations inutiles. Donnez un aper\xe7u concis en un seul paragraphe.",
    'highlight-actions.rovo-chat.button-text': "Conversation instantan\xe9e",
    'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Demander dans le chat',
    'horizontal-scroll-container.scroll-left': "Faire d\xe9filer vers la gauche",
    'horizontal-scroll-container.scroll-right': "Faire d\xe9filer vers la droite"
};

});


//# sourceMappingURL=fr.a8a960f3.js.map
